import A from './types';
import filter from 'lodash/filter';

import getStorageValue from '~/misc/getStorageValue';

const initSwitchData = {
  loading: false,
  error: false,
  tool_switch: 0,
  tool_window: {
    title: 'Rate Check Algorithm optimization',
    content: 'We have optimized the algorithm of Rate',
  },
};

const initialState = {
  sdRateAverage: 'undefined',
  sdSumDistance: 'undefined',
  sdSumPrice: 'undefined',
  fuelPriceAvg: 'undefined',
  pickLoads: 'undefined',
  pickTruck: 'undefined',
  dropLoads: 'undefined',
  dropTrucks: 'undefined',
  fuelPrice: '',
  basePrice: '',
  milesPrice: '',
  deadhead: 200,
  rate_switch: initSwitchData,

};

const getSwitchAndInitData = (data, obj) => {
  const switchData = getStorageValue('rateSwitch') ? Number(getStorageValue('rateSwitch')) : obj.tool_switch;
  const toolSwitch = switchData ? 1 : 0;
  const newObj = Object.assign({}, obj, {tool_switch: toolSwitch});

  return Object.assign({}, data, newObj);
};

const saveSwitchAndSetState = (state) => {
  window.localStorage.setItem('rateSwitch', 0);
  return {
    ...state,
    rate_switch: Object.assign({}, state.rate_switch, {tool_switch: 0}),
  };
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.INIT_RATE_CHECK: {
      return Object.assign({}, state, action.payload);
    }
    case A.REMOVE_RATE_CHECK: {
      return Object.assign({}, state, initialState);
    }
    case A.GET_RATE_UPDATE_SWITCH: {
      if (action.pending) {
        return {
          ...state,
          rate_switch: getSwitchAndInitData(initSwitchData, {loading: true, error: false}),
        };
      }
      if (action.payload.message.toLowerCase() === 'success') {
        return {
          ...state,
          rate_switch: getSwitchAndInitData(state.rate_switch, {...action.payload.data, loading: false, error: false}),
        };
      }
      return {
        ...state,
        rate_switch: getSwitchAndInitData(
          initSwitchData,
          {loading: false, error: action.payload.message || action.error}),
      };
    }
    case A.SAVE_RATE_SWITCH: {
      return saveSwitchAndSetState(state);
    }
  }
  return null;
};
export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/rate/reducer.js